// extracted by mini-css-extract-plugin
export default {"linha":"footer_linha__bQsOe","footer":"footer_footer__R1A6a","redesIcons":"footer_redesIcons__2ON++"};